<template>
    <div class="tab-training">
        <folder
            v-if="showInvites"
            title="Приглашения"
            class="folder"
            color="blue"
        >
            <education-events
                ref="invites"
                invites="events"
                @update="checkInvites"
            />
        </folder>
        <folder
            title="Мероприятия"
            class="folder"
        >
            <education-events
                ref="events"
                type="events"
            />
        </folder>
    </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';

import Folder from '@/components/UI/Folder';
import EducationEvents from './tab-training/EducationEvents';

const eventsActions = [
    'fetchEvents',
];

export default {
    name: 'TabEvents',
    components: {
        Folder,
        EducationEvents,
    },
    data: () => ({
        showInvites: false,
    }),
    created() {
        this.checkInvites();
    },
    methods: {
        async checkInvites() {
            const response = await this.fetchEvents({
                type: 'full_time',
                status: 'public,private',
                limit: 1,
                offset: 0,
                self: true,
                participantStatuses: ['admin_sent_request'],
            });
            
            this.showInvites = !!response.count;

            if (this.$refs.invites) this.$refs.invites.reloadData();
            this.$refs.events.reloadData();
        },
        ...mapActions('events', eventsActions),
    },
};
</script>

<style lang="scss" scoped>
@import '@/styles/rem';

.tab-training{
    .folder{
        margin-bottom: 1rem;

        @include on-mobile {
            margin-bottom: mrem(24);
        }

        &:last-of-type {
            @include on-mobile {
                margin-bottom: 0;
            }
        }

        .empty {
            width: 100%;
            height: 3rem;
            display: flex;
            -webkit-box-pack: center;
            -ms-flex-pack: center;
            justify-content: flex-start;
            -webkit-box-align: center;
            -ms-flex-align: center;
            align-items: center;
            color: #98A0A9;
            font-size: .9rem;

            @include on-mobile {
                font-size: mrem(14);
                margin-bottom: mrem(24);
            }
        }
    }
}
</style>
